// core
import React, {useEffect} from 'react'
// components
import {Footer, Header} from "../../components";
import {getAnalytics, logEvent} from "firebase/analytics";

export const Layout = ({
                           children,
                           classes,
                           notification
                       }) => {


    const analytics = getAnalytics();
    useEffect(() => {
        logEvent(analytics, 'page_view', {
            page_path: window.location.pathname
        });
    })

    if (notification) {
        logEvent(analytics, 'notification', notification);
    }
    return (
        <>
            <Header/>
            <main className={classes}>
                {children}</main>
            <Footer/>
        </>
    )
};
